import { Routes } from '@angular/router';

/**
 * Top-level application routing configuration with lazy-loaded standalone components.
 */
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'devices_last_seen',
    pathMatch: 'full'
  },
  {
    path: 'devices_last_seen',
    loadComponent: () => import('./components/device-last-seen/device-last-seen.component').then(m => m.DeviceLastSeenComponent)
  },
  {
    path: 'devices_battery',
    loadComponent: () => import('./components/device-battery/device-battery.component').then(m => m.DeviceBatteryComponent)
  },
  {
    path: 'presences',
    loadComponent: () => import('./components/presences/presences.component').then(m => m.PresencesComponent)
  },
  {
    path: 'tasks',
    loadComponent: () => import('./components/tasks-overview/tasks-overview.component').then(m => m.TasksOverviewComponent)
  },
  {
    path: 'sessions_total_count',
    loadComponent: () => import('./components/sessions-total-count/sessions-total-count.component').then(m => m.SessionsTotalCountComponent)
  }
];
